import cloneDeep from 'lodash/cloneDeep';

interface IcodeItem {
  code: string;
  subCode?: Array<string>;
}

export function formatCode(propsData) {
  const data = cloneDeep(propsData);
  const code: Array<IcodeItem> = [];
  data?.split(',')?.forEach((item) => {
    const codeArr = item.split('_');
    const currentCode: IcodeItem | undefined = code.find((v) => v.code === codeArr[0]);
    if (currentCode) {
      currentCode?.subCode?.push(codeArr[1]);
    } else if (codeArr[1] && codeArr[1] !== '-1') {
      code.push({
        code: codeArr[0],
        subCode: [codeArr[1]],
      });
    } else {
      code.push({
        code: codeArr[0],
      });
    }
  });
  return code;
}

export function formatSearchQuery(propsParams) {
  const params = cloneDeep(propsParams);
  const {
    keyword,
    hiringType: propsHiringType,
    jfJgList: propsJfJgList,
    cityList: propsCityList,
    bg: propsBg,
    jobUnionIds,
    jobShareType,
    hiringSpecial,
  } = params;
  const hiringType = propsHiringType?.toString();
  const jfJgList = propsJfJgList?.toString();
  const cityList = propsCityList?.toString();
  const bg = propsBg?.toString();
  let fetchObj = {};

  if (keyword) {
    try {
      fetchObj = {
        ...fetchObj,
        keywords: decodeURIComponent(keyword)?.trim(),
      };
    } catch (e) {
      fetchObj = {
        ...fetchObj,
        keywords: keyword?.trim(),
      };
    }
  }
  if (hiringSpecial && hiringSpecial?.split(',')?.filter((item) => !!item).length > 0) {
    const specialCode = hiringSpecial.split(',')?.filter((item) => !!item);
    fetchObj = {
      ...fetchObj,
      specialCode,
    };
  }
  if (hiringType && hiringType?.split(',')?.filter((item) => !!item).length > 0) {
    const jobType = formatCode(hiringType);
    const typeCode = formatCode(hiringType)
      .filter((item) => item.subCode && item.subCode.length > 0)
      .map((item) => item.subCode)
      .flat();
    fetchObj = {
      ...fetchObj,
      jobType,
      typeCode,
    };
  }
  if (jfJgList && jfJgList?.split(',')?.filter((item) => !!item).length > 0) {
    const list = formatCode(jfJgList);
    fetchObj = {
      ...fetchObj,
      jfJgList: list,
    };
  }
  if (cityList && cityList?.split(',')?.filter((item) => !!item).length > 0) {
    fetchObj = {
      ...fetchObj,
      cityList: cityList?.split(',')?.map((v) => {
        // 热门海外城市-处理选择全部的情况
        if (v?.includes('_-1')) {
          const [_code] = v.split('_');
          return { code: _code };
        }
        // 热门海外城市-处理选择普通二级的情况
        if (v?.includes('_')) {
          const [, subCode] = v.split('_');
          return { code: subCode };
        }
        return { code: v };
      }),
    };
  }
  if (bg && bg?.split(',')?.filter((item) => !!item).length > 0) {
    fetchObj = {
      ...fetchObj,
      department: bg?.split(',')?.map((v) => ({ code: v })),
    };
  }
  if (jobUnionIds && jobUnionIds?.length > 0) {
    fetchObj = {
      ...fetchObj,
      jobUnionIds,
    };
  }
  fetchObj = {
    ...fetchObj,
    jobShareType: jobShareType || '1',
  };
  return fetchObj;
}

// 处理子节点带父节点
export default (data, isAddAll?: boolean) => {
  if (!data || data?.length === 0) return [];
  const cloneData = cloneDeep(data);
  return cloneData?.map((dataItem) => {
    const obj = {
      ...dataItem,
    };
    const { children = [] } = dataItem;
    if (isAddAll && children?.length > 0) {
      children.unshift({
        code: '-1',
        name: '全部',
      });
    }
    const newChild = children?.map((childrenItem) => {
      return {
        ...childrenItem,
        code: `${dataItem?.code}_${childrenItem?.code}`,
      };
    });
    obj.children = newChild;
    return obj;
  });
};
